// @ts-nocheck
import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import './styles.css';
import _, { has } from 'lodash';

const STARTER_DIVISIONS = [
  'Open Division',
  'Upper Division',
  'Recreational Division'
];

const DEFAULT_PLAYER_FIELD = [
  // {
  //   name: 'Name',
  //   required: true,
  //   helperText: 'Please enter your full name',
  //   include: true
  // },
  {
    name: 'Phone',
    required: false,
    helperText: 'Please enter this players phone number',
    include: false,
    error: {
      name: '',
      helperText: ''
    }
  },
  {
    name: 'Notes',
    required: false,
    helperText: 'Enter player height, years of experience, etc',
    include: false,
    error: {
      name: '',
      helperText: ''
    }
  }
];

const CreateLeagueRegistration = ({ season, league }) => {
  const [divisions, setDivisions] = useState(STARTER_DIVISIONS);
  const [fields, setFields] = useState(DEFAULT_PLAYER_FIELD);
  const [requirePlayers, setRequirePlayers] = useState(true);
  const [hasPayments, setHasPayments] = useState(false);
  const [hasDeadline, setHasDeadline] = useState(false);
  console.log('CreateRegistration::', divisions, fields, requirePlayers);
  const onSubmit = () => {
    const returnObject = {
      divisions,
      fields: _.filter(fields, { include: true }),
      requirePlayers,
      hasPayments,
    };
    console.log('returnObject::', returnObject);
    console.log('onSubmit::', divisions, fields, requirePlayers, hasPayments);
  };

  return (
    <div>
      Create Registration
      <br />
      <TextField
        label={'Message/Notes to Team Managers'}
        helperText={'Let team managers know any important information to include '}
        multiline
        rows={2}
        maxRows={4}
        />
      <br />
      <br />
      <Typography variant="subtitle1">Include Registration Deadline:</Typography>
      <RadioGroup
        aria-label="include players"
        name="includePlayers"
        className={'group'}
        value={hasDeadline}
        onClick={e => setHasDeadline(e.target.value === 'true')} >
        <FormControlLabel  value={true} control={<Radio />} label={'Yes'} />
        <FormControlLabel  value={false} control={<Radio />} label={'No'} />
      </RadioGroup>
      <br />
      <br />
      <Typography variant="subtitle1">Include Payments</Typography>
      <RadioGroup
        aria-label="include players"
        name="includePlayers"
        className={'group'}
        value={hasPayments}
        onClick={e => setHasPayments(e.target.value === 'true')} >
        <FormControlLabel  value={true} control={<Radio />} label={'Yes'} />
        <FormControlLabel  value={false} control={<Radio />} label={'No'} />
      </RadioGroup>
      <br />
      <br />
      <Typography variant="subtitle1">Include Players:</Typography>
      <RadioGroup
        aria-label="include players"
        name="includePlayers"
        className={'group'}
        value={requirePlayers}
        
        onClick={e => setRequirePlayers(e.target.value === 'true')} >
        <FormControlLabel value={true} control={<Radio />} label={'Yes'} />
        <FormControlLabel value={false} control={<Radio />} label={'No'} />
      </RadioGroup>
      <h3>Player Fields</h3>
      <br />
      {requirePlayers ? (
      <div id="myForm">
        
          <div className="header">Field Name</div>
          <div className="header">Helper Text</div>
          <div className="header">Required</div>
          <div className="header">Include</div>
          <div style={{ textAlign: 'center', alignSelf: 'center' }}>Player Name</div>
          <div style={{ textAlign: 'center', alignSelf: 'center' }}>Enter player name</div>
          <div style={{ textAlign: 'center', alignSelf: 'center' }}>X</div>
          <div style={{ textAlign: 'center', alignSelf: 'center' }}>X</div>
          {fields.map((field, index) => {
            return (
              <>
            <TextField
              label={'Field Name'}
              error={field.error.name}
              variant="outlined"
              value={field.name}
              disabled={!field.include}
              helperText={field.error.name || ''}
              onChange={(e) => {
                const newFields = [...fields];
                newFields[index].name = e.target.value;
                if (!e.target.value) {
                  newFields[index].error.name = 'Field name is required';
                } else {
                  newFields[index].error.name = '';
                }
                setFields(newFields);
              }}
            />
            <TextField
              label={'Helper Text'}
              error={field.error.helperText}
              style={{ width: '350px' }}
              variant="outlined"
              value={field.helperText}
              maxLength={50}
              disabled={!field.include}
              helperText={field.error.helperText || ''}
              onChange={(e) => {
                const newFields = [...fields];
                newFields[index].helperText = e.target.value;
                if (!e.target.value) {
                  newFields[index].error.helperText = 'Helper text is required';
                } else {
                  newFields[index].error.helperText = '';
                }
                setFields(newFields);
              }}
            />
            <Checkbox
              native
              value={field.required}
              disabled={!field.include}
              onChange={(e) => {
                const newFields = [...fields];
                console.log('onChange::', e.target.checked);
                newFields[index].required = e.target.checked;
                console.log('onChange2::', newFields[index]);
                setFields(newFields);
              }}
              checked={field.required}
              />
            <Checkbox
              native
              value={field.include}
              onChange={(e) => {
                const newFields = [...fields];
                console.log('onChange::', e.target.checked);
                newFields[index].include = e.target.checked;
                console.log('onChange2::', newFields[index]);
                setFields(newFields);
              }}
              checked={field.include}
              />
              </>
            )
          })}
        </div>
    ) : null}
      <br />
      <h3>Divisions (Can be added later)</h3>
      <br />
      {divisions.map((division, index) => {
        return (
          <div key={index} style={{ margin: '5px 0px'}}>
            <TextField
              label={'Division Name'}
              variant="outlined"
              value={division}
              onChange={(e) => {
                const newDivisions = [...divisions];
                newDivisions[index] = e.target.value;
                setDivisions(newDivisions);
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                const newDivisions = [...divisions];
                newDivisions.splice(index, 1);
                setDivisions(newDivisions);
              }}
            >
              X
            </Button>
          </div>
        )
      })}
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          setDivisions([...divisions, '']);
        }}
      >
        Add Division
      </Button>
      <br />
      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          onSubmit();
        }}
      >
        Submit2
        </Button>
    </div>
  );
};

export default CreateLeagueRegistration;